module.exports = __webpack_public_path__ + "img/mealkit.b480bb1a.svg";